// 大小写字母 + 数字 + 特殊字符 长度大于等于 8 位
export const PWD_REG = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*"'()+,-./:;<=>?[\]^_`{|}~])(?=.{8,})/;

// 大小写字母 + 数字 最少 8 位
export const API_ID_REG = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;

// 判断是否有内容 排除首位空格
export const HAS_CONTENT = /^\S.\S$/;

// 大小写字母、数字、“-”，无空格 长度为1-20位
export const DOMAIN_NAME = /^[A-Za-z0-9.-]{1,20}$/;

//长度不超过100个字符，由大小写字母、数字、特殊字符组成，无空格
export const DOMAIN_API_ID = /^[A-Za-z0-9@#$%&*+\-_(){}<>^~,+`'\":;?.,!|\\/]{0,99}$/;

// 大写字母 或 小写字母 或 数字
export const NO_SPECIAL_CHARACTERS = /^[a-zA-Z0-9]+$/;

// IPV4 地址
export const IPV4_REG = /^((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])(?::(?:[0-9]|[1-9][0-9]{1,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5]))?$/
